module.exports = __webpack_public_path__ + "img/gsgsxywz.28ec6a46.png";